
import { Component, Prop, Emit } from 'vue-property-decorator'
import { AppButton, AppBox, AppInput, AppButtonOutline } from '@/components'
import { appEntity } from '@/models/models'
import { mixins } from 'vue-class-component'
import { ChildComponentMixin } from '@/mixins'
import DetailBasicImageForm from './DetailBasicImageForm.vue'
import { debounce, DebouncedFunc, cloneDeep, merge } from 'lodash'
import '@/extensions/string'
import '@/plugins/fontawesome'

@Component({
    components: {
        AppButton,
        AppButtonOutline,
        AppBox,
        AppInput,
        DetailBasicImageForm,
    },
})
export default class DetailBasicForm extends mixins(ChildComponentMixin) {
    @Prop() public value?: AppEntity
    @Prop() public hideCard?: boolean
    private debounced: DebouncedFunc<(() => {})> | null = null
    private packageNameCopy = {
        hint: 'Clique no ícone para copiar o link',
        icon: 'copy',
    }

    get brandId() {
        return this.app.brand.id > 0 ? this.app.brand.id.toString() : ''
    }

    get app(): AppEntity {
        return this.value ?? appEntity
    }

    get hasApp(): boolean {
        return this.app.id > 0
    }

    get brandStatus(): string {
        return this.app.brand.numberOfStores > 0 ? 'Ativa' : 'Desativada'
    }

    get packageName(): string {
        return `com.delivery.${this.app.idSuffix}`
    }

    get readonlyPackageName(): boolean {
        if (this.app?.id === 0 || this.app?.id == null) {
            return false
        }
        return true
    }

    public goToBrand(encodedName: string) {
        window.open(
            `https://deliverydireto.com.br/admin/${encodedName}`,
            '_blank',
        )
    }

    public copyToClipboard(e: Event) {
        (document.querySelector('#packageName input') as any).select()
        document.execCommand('copy')

        this.packageNameCopy.hint = 'Copiado'
        this.packageNameCopy.icon = 'check-circle'
    }

    private validateNotEmpty(value: string, error: string) {
        if (value != null && value.length === 0) {
            this.app.errors = {
                ...this.app.errors,
                ...{ [error]: 'Não pode ser vazio' },
            }
        }

        this.onInput(this.app)
    }

    @Emit('input')
    private onInput(app: AppEntity) {
        return app
    }

    private onEditAppPackageName(packageName: string) {
        const idSuffix = packageName.replace('com.delivery.', '')
        this.update(this.app, 'idSuffix', idSuffix)
    }

    private async onEditAppId(id: number) {
        const app = cloneDeep(appEntity)
        app.brand.id = id
        this.onInput(app)

        if (this.debounced != null) {
            this.debounced.cancel()
        }

        this.debounced = debounce(async () => {
            let appWithBrand = await this.$store.dispatch(
                'detail/searchBrandById',
                id,
            )

            if (appWithBrand == null) {
                app.errors.brand = 'Brand não encontrada'
            }

            const templateApp = cloneDeep(app)
            appWithBrand = merge(templateApp, appWithBrand)
            this.onInput(appWithBrand)
        }, 500)

        this.debounced()
    }
}
